import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { addCommas } from '../../../utils/utils';
import { isDisplayCost } from '../../../utils/orderUtils';
import moment from "moment";
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    fontSize: 15,
    fontWeight: 'bold',
  },

  caption: {
    marginRight: 10,
  },
});

const ItemTitle = props => {
  const { classes, item, user } = props;

  const target = (item.letter_order) ? item.letter_order : item.follow_call_order;
  const isOrderProcessDone = target.latest_order_address;

  return (
    <div className={classes.root}>
      <span className={classes.caption}>{moment(target.created_at).format("YYYY/MM/DD")}</span>
      {isOrderProcessDone ? (
        <span>
          {addCommas(target.order_addresses_count)}件{(isDisplayCost(item, user)) ? `（¥${addCommas(target.total_cost)}）` : ""}の{(item.letter_order) ? "レター" : "フォローコール"}を注文しました。
        </span>
      ) : (
        <span>注文処理中です。</span>
      )}
    </div>
  );
}

ItemTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ItemTitle));



// WEBPACK FOOTER //
// ./src/components/OrderList/parts/ItemTitle.jsx